import React from 'react';
import './SubscriptionExpiredScreen.css';
import { IconMail, IconGlobe, IconClock } from './Icons';

function SubscriptionExpiredScreen({ onLogout }) {
  return (
    <div className="subscription-expired-container">
      <div className="expired-card">
        <div className="expired-icon" style={{ color: '#ffb74d' }}><IconClock size={52} /></div>
        <h2>Пробный период истек</h2>
        <p className="expired-description">
          Ваш 7-дневный пробный период закончился. Чтобы продолжить использовать 
          Анализатор Открытых Вопросов, выберите подходящий тариф.
        </p>

        <div className="pricing-options">
          <div className="pricing-card basic">
            <h3>Базовый</h3>
            <div className="price">4 990 руб.</div>
            <div className="price-note">за один проект</div>
            <ul>
              <li>Базовая кластеризация</li>
              <li>Ручное редактирование</li>
              <li>Excel визуализация</li>
            </ul>
          </div>

          <div className="pricing-card standard recommended">
            <div className="badge">Рекомендуем</div>
            <h3>Стандарт</h3>
            <div className="price">от 19 990 руб./мес</div>
            <div className="price-note">подписка</div>
            <ul>
              <li>Продвинутая ИИ-кластеризация</li>
              <li>ИИ-ассистент редактирования</li>
              <li>Разработчик ядра ИИ</li>
              <li>Интерактивные карты + инсайты</li>
            </ul>
          </div>
        </div>

        <div className="expired-actions">
          <p className="contact-text">
            Для оформления подписки свяжитесь с нами:
          </p>
          <div className="contact-info">
            <span><IconMail size={15} style={{ marginRight: '6px', marginTop: '-2px' }} />info@crea-project.ru</span>
            <span><IconGlobe size={15} style={{ marginRight: '6px', marginTop: '-2px' }} />www.crea-project.ru</span>
          </div>
          <button className="logout-button" onClick={onLogout}>
            Выйти из аккаунта
          </button>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionExpiredScreen;
